// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3cdK6","checkboxCol":"Table_checkboxCol__1VcAG","emailCol":"Table_emailCol__3nLFl","actionCol":"Table_actionCol__MjBxV"};